import { render } from "./Privacy.vue?vue&type=template&id=61f4ad52"
import script from "./Privacy.vue?vue&type=script&setup=true&lang=js"
export * from "./Privacy.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "/var/www/html/lasource-2023/laravel/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/cartes-cadeaux/pages/Privacy.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "61f4ad52"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('61f4ad52', __exports__)) {
    console.log('reload')
    api.reload('61f4ad52', __exports__)
  }
  
  module.hot.accept("./Privacy.vue?vue&type=template&id=61f4ad52", () => {
    console.log('re-render')
    api.rerender('61f4ad52', render)
  })

}


export default __exports__